module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('h2', {
    staticClass: "fmtitle"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("Dedication")])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("To my dad, Gilberto Romero (1919–2009), for teaching me to read and to love books and to believe I could do anything I wanted to do. I did it, Daddy.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("To my son, Paul Michael Anthony Bennett, for believing that having a mom who writes murder mysteries makes for a normal childhood.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("To my husband and best friend, Paul, for always believing that it was a matter of “when”, not “if”.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13a0f472","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/02_Dedication.vue
// module id = 72
// module chunks = 0